import {
  GlAccountBalance,
  GlAccountClassification,
  GlAccountSortField,
  GlAccountSubType,
  GlAccountType,
  ReportingAccountType,
} from "@/graphql/codegen/graphql"

export const ACCOUNT_CLASSIFICATION_LABELS = {
  [GlAccountClassification.IncomeStatement]: "Income Statement",
  [GlAccountClassification.BalanceSheet]: "Balance Sheet",
} as const

export const ACCOUNT_TYPE_LABELS = {
  [GlAccountType.Asset]: "Asset",
  [GlAccountType.Liability]: "Liability",
  [GlAccountType.Equity]: "Equity",
  [GlAccountType.Revenue]: "Revenue",
  [GlAccountType.Expense]: "Expense",
} as const

export const REPORTING_ACCOUNT_TYPE_LABELS = {
  [ReportingAccountType.Parent]: "Parent Account",
  [ReportingAccountType.Posting]: "Posting Account",
} as const

export const ACCOUNT_BALANCE_LABELS = {
  [GlAccountBalance.Debit]: "Debit",
  [GlAccountBalance.Credit]: "Credit",
} as const

export const ACCOUNT_SUBTYPE_LABELS = {
  [GlAccountSubType.Cash]: "Cash",
  [GlAccountSubType.AccountsReceivable]: "Accounts Receivable",
  [GlAccountSubType.OtherAssets]: "Other Assets",
  [GlAccountSubType.Inventory]: "Inventory",
  [GlAccountSubType.FixedAssets]: "Fixed Assets",
  [GlAccountSubType.Payables]: "Payables",
  [GlAccountSubType.AccruedCorporateTaxes]: "Accrued Corporate Taxes",
  [GlAccountSubType.AccruedOther]: "Accrued Other",
  [GlAccountSubType.ReserveForFederalTaxes]: "Reserve for Federal Taxes",
  [GlAccountSubType.NetWorth]: "Net Worth",
  [GlAccountSubType.OtherRevenue]: "Other Revenue",
  [GlAccountSubType.Sales]: "Sales",
  [GlAccountSubType.CostOfGoodsSold]: "Cost of Goods Sold",
  [GlAccountSubType.DepreciationAmortization]: "Depreciation & Amortization",
  [GlAccountSubType.MiscTaxes]: "Misc Taxes",
  [GlAccountSubType.CapitalInsurance]: "Capital Insurance",
  [GlAccountSubType.MedicalInsurance]: "Medical Insurance",
  [GlAccountSubType.Advertising]: "Advertising",
  [GlAccountSubType.CorporateDonations]: "Corporate Donations",
  [GlAccountSubType.InterestExpense]: "Interest Expense",
  [GlAccountSubType.BadDebt]: "Bad Debt",
  [GlAccountSubType.SalaryManagement]: "Salary - Management",
  [GlAccountSubType.SalaryPayPool]: "Salary - Pay Pool",
  [GlAccountSubType.SalarySales]: "Salary - Sales",
  [GlAccountSubType.SalaryLab]: "Salary - Lab",
  [GlAccountSubType.SalaryOffice]: "Salary - Office",
  [GlAccountSubType.SalaryWarehouse]: "Salary - Warehouse",
  [GlAccountSubType.ProfitSharing]: "Profit Sharing",
  [GlAccountSubType.CorporateReserve]: "Corporate Reserve",
  [GlAccountSubType.CorporateIncomeTax]: "Corporate Income Tax",
  [GlAccountSubType.AccruedOverhead]: "Accrued Overhead",
  [GlAccountSubType.TravelEntertainment]: "Travel & Entertainment",
  [GlAccountSubType.GeneralExpense]: "General Expense",
  [GlAccountSubType.Lifo]: "LIFO",
  [GlAccountSubType.WarehouseExpense]: "Warehouse Expense",
  [GlAccountSubType.ProgrammingExpense]: "Programming Expense",
} as const

export const CHART_OF_ACCOUNTS_SORT_FIELD_LABELS = {
  [GlAccountSortField.Number]: "Account Number",
  [GlAccountSortField.Title]: "Account Title",
  [GlAccountSortField.ParentAccount]: "Parent Account",
  [GlAccountSortField.Type]: "Type",
} as const

// Account types allowed for each classification (AC3 requirement)
export const CLASSIFICATION_ACCOUNT_TYPES = {
  [GlAccountClassification.IncomeStatement]: [GlAccountType.Revenue, GlAccountType.Expense],
  [GlAccountClassification.BalanceSheet]: [GlAccountType.Asset, GlAccountType.Liability, GlAccountType.Equity],
} as const

export const CHART_OF_ACCOUNTS_SEARCH_PLACEHOLDER = "Search by Account Number or Account Title"

export const MAX_SUB_NUMBER_LENGTH = 2 // AS400 constraint
